<template>
    <div class="hub-pool">
        <b-card no-body>
            <b-card-header class="px-3 py-2">
                <b-row align-v="center">
                    <b-col cols="10">
                        <h3 class="mb-0">
                            Hub Pool
                        </h3>
                    </b-col>
                    <b-col cols="2">
                        <b-link href="#" class="d-flex align-items-center float-right py-0 text-primary">
                            View
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="text-primary"><path fill="currentColor" d="M9.4 18 8 16.6l4.6-4.6L8 7.4 9.4 6l6 6-6 6Z"/></svg>
                        </b-link>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-container class="px-3 pt-3">
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <p class="mb-0">Current Quarterly Pool</p>
                        <h3 class="font-weight-bold mb-0">RM {{ pool_total | moneyFormatter }}</h3>
                    </b-col>
                    <b-col cols="12" class="mb-3">
                        <p class="mb-0">Total Pool Tokens</p>
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="mr-2" viewBox="0 0 512 512"><path fill="#DC9A0F" d="M512 80c0 18-14.3 34.6-38.4 48-29.1 16.1-72.5 27.5-122.3 30.9-3.7-1.8-7.4-3.5-11.3-5-39.4-16.5-91.8-25.9-148-25.9-8.3 0-16.4.2-24.5.6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80s192 35.8 192 80zm-351.3 81.1c10.2-.7 20.7-1.1 31.3-1.1 62.2 0 117.4 12.3 152.5 31.4 24.8 13.5 39.5 30.3 39.5 48.6 0 4-.7 7.9-2.1 11.7-4.6 13.2-17 25.3-35 35.5-.1.1-.3.1-.4.2-.3.2-.6.3-.9.5-35 19.4-90.8 32-153.6 32-59.6 0-112.9-11.3-148.2-29.1-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4 10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4 28.3-4.4 54.2-11.4 76.2-20.5 16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9-14.6 7.4-32.4 13.7-52.4 18.5.1-1.8.2-3.5.2-5.3zm-32 96c0 18-14.3 34.6-38.4 48-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336v-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9 6.1-3.4 11.8-7.2 17.2-11.2 1.5-1.1 2.9-2.3 4.3-3.4V336zm32 0v-57.9c19-4.2 36.5-9.5 52.1-16 16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9-16.3 16.3-45 29.7-81.3 38.4.1-1.7.2-3.5.2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9 16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432v-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"/></svg>
                                <p class="mb-0 font-weight-500">10 Tokens</p>
                            </div>
                            <p class="mb-0 text-muted">1 token = RM21,000</p>
                        </div>
                    </b-col>
                    <b-col>
                        <b-link href="#" class="mb-0 text-primary" @click="modals.show_table = true">View Details</b-link>
                    </b-col>
                </b-row>
            </b-container>
            <PoolContributionDetailsTableModal :show_table.sync="modals.show_table"/>
        </b-card>
    </div>
</template>
<script>
import { axios, services, getHeader,debounce } from '@/assets/js/httpImports.js'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import PoolContributionDetailsTableModal from '@/views/Commission/Hub/HubProfile/HubModals/ShowTableModals/PoolContributionDetailsTableModal'
export default {
    props: ['date_picked'],
    mixins: [clientPaginationMixin],
    components: {
        PoolContributionDetailsTableModal,
    },
    data() {
        return {
            pool_total: null,
            modals:{
                show_table: false
            },
        }
    },
    watch: {
        date_picked(newValue) {
            if(newValue)
            {
                this.getCurrentPoolTotal();
            }
        }
    },
    created() {
        this.getCurrentPoolTotal();
    },
    methods: {
        getCurrentPoolTotal() {
            let queryparams = "";

            if(this.date_picked)
            {
                queryparams = '/' + this.date_picked[0] + '/' + this.date_picked[1];
            }

            axios.get(services.hub + 'hub_comms/pool.show_current_quater_pool' + queryparams, { headers: getHeader() })
            .then(res => {
                this.pool_total = res.data.data.pool_total
            })
            .catch ( error => {
                this.errorFunction(error, "Error " + error.response.data.message) 
            });
        }
    },
}
</script>